import { useAppSelector } from "../../../state/store"

export const useCheckout = () => useAppSelector((state) => state.checkout)
export const useBasket = () => useCheckout().basket
